<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-order-view" class="data-list-container">
		<vs-table :sst="true" class="shadow-none border-none table-auto" stripe :data="$store.state.moduleProduct && $store.state.moduleProduct.shippings" @sort="handleSort">
			<div slot="header" class="w-full mb-12 flex">
				<h4 class="font-bold">Vận đơn thủy sản</h4>
				<div class="flex flex-grow justify-end">
					<vs-input @input="handleSearch" size="large" class="input-search mr-3 md:block lg:block xl:block" icon="search" :placeholder="'Tìm theo vựa cá'" v-model="searchText" />
				</div>
			</div>
			<div slot="header" class="mb-12 w-full" style="align-items: center; display: flex;flex-direction: row;width: 100%;overflow-x: scroll;">
				<h4 class="font-bold">Vận đơn</h4>
				<!-- <div class="" :key="`${upStatus}--1`" style="min-width: 100px; margin-left: 15px;">
					<vs-button title="Tìm theo khớp giá" class="font-bold ml-3 w-full" :color="'#626262'" :type="isAll ? 'filled' : 'border'" @click="filterByStatus(-1)">Tất cả</vs-button>
				</div> -->
				<div class="" :key="`${upStatus}-${idxStatus}`" v-for="(statusLabel, idxStatus) in statusList" style="min-width: 150px; margin-left: 15px;">
					<vs-button class="font-bold ml-3 w-full" :color="statusLabel.color" :type="statusLabel.active ? 'filled' : 'border'" @click="filterByStatus(idxStatus)">{{statusLabel.name}}</vs-button>
				</div>
				<!-- <div class="" style="min-width: 100px; margin-left: 100px;">
					<vs-button title="Lọc dữ liệu" class="font-bold ml-3 w-full" :color="'#2B59B2'" :type="filterDialog ? 'filled' : 'border'" @click="applyFilterDialog()">Bộ lọc</vs-button>
				</div> -->
				<div class="" style="min-width: 150px; margin-left: 15px;">
					<vs-button class="font-bold ml-3 w-full" :color="'#2B59B2'" :type="'border'" @click="toggleReportDialog(true)">Tải báo cáo</vs-button>
				</div>
			</div>
			<template slot="thead">
				<vs-th sort-key="code" style="min-width:100px;"><h6 class="uppercase font-bold">Mã</h6></vs-th>
				<vs-th sort-key="code" style="min-width:200px;"><h6 class="uppercase font-bold">Người mua</h6></vs-th>
				<vs-th sort-key="name" style="min-width:120px;"><h6 class="uppercase font-bold">Mặt hàng</h6></vs-th>
				<vs-th sort-key="name" style="min-width:120px;"><h6 class="uppercase font-bold">Ngày giao</h6></vs-th>
				<vs-th sort-key="price" style="min-width:100px;"><h6 class="uppercase font-bold">Số bao</h6></vs-th>
				<vs-th sort-key="price" style="min-width:100px;"><h6 class="uppercase font-bold">Quy cách</h6></vs-th>
				<vs-th sort-key="price" style="min-width:100px;"><h6 class="uppercase font-bold">Phương tiện</h6></vs-th>
				<vs-th sort-key="status" style="min-width:140px;"><h6 class="uppercase font-bold">Trạng thái VĐ</h6></vs-th>
				<vs-th sort-key="status" style="min-width:140px;"><h6 class="uppercase font-bold">Trạng thái TT</h6></vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="onClickEditOrder(tr, $event)">
					<vs-td>
						<p class="word-break uppercase">
							#{{ tr.code }}
						</p>
					</vs-td>
					<vs-td>
						<p class="word-break uppercase">
							{{ tr.matching ? (tr.matching.cus_name ? tr.matching.cus_name : '-') : '-' }}
						</p>
					</vs-td>
					<vs-td>
						<p class="word-break">
							{{ tr.matching ? (tr.matching.product ? tr.matching.product.name : '-') : '-' }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{ 'word-break': 1, }">
							{{ $helper.momentFormat(tr.shipping_date) }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{ 'word-break': 1, 'text-right': 1 }">
							Y: {{ $helper.numFormat(tr.so_bao_ca_y) }} / Dạt: {{ $helper.numFormat(tr.so_bao_ca_dat) }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{ 'word-break': 1, 'text-right': 1 }">
							{{ tr.packing_unit }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{ 'word-break': 1 }">
							{{tr.vehicle_type == 1 ? 'Xe tải' : (tr.vehicle_type == 4 ? 'Xe ba gác' : 'Ghe')}} BS: {{ tr.vehicle_no }}
						</p>
					</vs-td>
					<vs-td :set="statusDirective = $helper.getStausShippingAqua(parseInt(tr.status))">
						<p :class="{ 'word-break': 1 }">
							<label :class="statusDirective.directive">
								{{ statusDirective.name}}
							</label>
						</p>
					</vs-td>
					<vs-td :set="statusDirective = $helper.getStatusAndDirectiveBillingAqua(tr.billing ? tr.billing.status : 0)">
						<p :class="{ 'word-break': 1 }">
							<label :class="statusDirective.directive">
								{{ statusDirective.name}}
							</label>
						</p>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
		<div class="w-full center mt-4">
			<CbsPagination :total="total" v-model="page"></CbsPagination>
		</div>
		<ThuNganForm :isPopupActive="customerDialog" @closePopup="toggleCustomerDialog" :data="customerData" />
		<OrderDetail :isPopupActive="isDetailUserDialogActive" @closePopup="toggleDetailSidebar" :data="detailUserDialogData" />
		<DialogAccountReportBB :isPopupActive="reportDialog" @closePopup="toggleReportDialog"/>
	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";
import ThuNganForm from "./ThuNganForm.vue";
import OrderDetail from "./OrderDetail.vue";
import DialogAccountReportBB from "./DialogAccountReportBB.vue";

export default {
	components: {
		CbsPagination,
		UserDetail,
		ThuNganForm,
		OrderDetail,
		DialogAccountReportBB
	},
	data() {
		return {
			reportDialog: false,
			upStatus: Date.now(),
			statusList: [
				{
					id: 0,
					name: window.innerWidth > 600 ? 'Đang chờ' : 'Đang chờ',
					active: 0,
					color: 'primary',
				},
				{
					id: 16,
					name: window.innerWidth > 600 ? 'Thanh 1 phần' : 'TT 1 phần',
					active: 0,
					color: 'warning',
				},
				{
					id: 2,
					name: window.innerWidth > 600 ? 'Đã thanh' : 'Đã thanh',
					active: 0,
					color: 'success',
				},
				// {
				// 	id: 128,
				// 	name: window.innerWidth > 600 ? 'Đã thanh toán' : 'Đã TT',
				// 	active: 0,
				// 	color: '#057FBB',
				// },
			],
			listUser: [],
			page: 1,
			searchText: "",
			userDialog: false,
			userData: {},
			detailUserDialogData: null,
			isDetailUserDialogActive: false,
			isDetailUserCustomerDialogActive: false,
			customerDialog: false,
			filters: {
				// status: 2
			},
			canView: false,
			canRating: false,
			customerData: {},
			userToken: '',
			isLoading: false,
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.moduleProduct.shippingsTotal / this.$store.state.moduleProduct.limit);
		},
	},
	methods: {
		toggleReportDialog(val = false) {
			this.reportDialog = val;
		},
		filterByStatus(idxStatus) {
			if (idxStatus == -1) {
				this.isAll = !this.isAll;
			} else {
				this.isAll = false;
			}
			this.statusList.map((status, index) => {
				// status.active = (index == idxStatus) ? !status.active : 0;
				if (this.isAll) {
					status.active = 0;
				}
				if (index == idxStatus) {
					status.active = !status.active;
				}
			});
			this.upStatus = Date.now();
			this.page = 1; // reset page
			this.getGetUsers();
		},
		printOrder(item) {
			console.log(item);
			// return;
            // var divContents = document.getElementById("test").innerHTML;
            var a = window.open(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+'/api/order-print/'+item.id+'?token='+this.userToken, '', 'height=500, width=500');
            // a.document.write('<html>');
            // a.document.write('<body > <h1>Div contents are <br>');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.document.close();
			// a.focus();
            // a.print();

			// a.addEventListener('load', function() {
			// 	a.print();
			// 	a.close();
			// }, true);
        },
		onClickCancelOrder(id, event) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: 'Thực hiện hủy lệnh số #'+id,
				// accept: () => this.deleteCustomer(customer._id),
				accept: () => this.cancelOrder(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
			if (event) {
				event.preventDefault()
			}
		},
		onClickEditOrder(data, event) {
			this.customerData = data;
			this.customerDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		async cancelOrder(id) {
			this.$vs.loading();
			try {
				let payload = {
					id: id
				};
				await this.$store.dispatch("moduleProduct/cancelOrder", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getProducts() {
			const payload = {
			};
			try {
				this.$store.dispatch("moduleProduct/fetchProducts", payload);
			} catch (error) {
				console.log(error.message);
			}
		},
		async getGetUsers() {
			if (this.isLoading) {
				return;
			}
			this.isLoading = true;
			this.$vs.loading();
			let statuses = [];
			this.statusList.map(status => {
				if (status.active) {
					statuses.push(status.id);
				}
			});
			const payload = {
				filters: this.filters,
				id: 0,
				search: '',
				searchBuyerName: this.searchText,
				page: this.page,
				limit: this.$store.state.moduleProduct.limit,
				type_variant: true,
				types: statuses
			};
			try {
				await this.$store.dispatch("moduleProduct/fetchShippings", payload);
				this.$vs.loading.close();
				this.isLoading = false;
			} catch (error) {
				this.$vs.loading.close();
				this.isLoading = false;
			}
		},
		handleSearch() {
			this.filters.search = this.searchText;
			if (this.searchText && this.searchText.length > 3) {
				this.getGetUsers();
			}
		},
		openUserForm(user) {
			if (user) {
				this.editUser(user);
			} else {
				this.addNewUser();
			}
		},
		addNewUser() {
			this.userData = {};
			this.toggleUserDialog(true);
		},
		editUser(user) {
			// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			this.userData = user;
			this.toggleUserDialog(true);
		},

		toggleUserDialog(val = false) {
			this.userDialog = val;
		},
		showDeleteUserConfirm(user) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteUser(user._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel"),
			});
		},
		async deleteUser(userId) {
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleUser/removeRecord", userId);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleOrderAction(type) {
			this.customerData.type = type;
			// this.customerData.product = this.detailUserDialogData;
			this.customerDialog = true;
		},
		handleClickItemRow(event, user) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find((className) => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
				this.detailUserDialogData = user;
				this.toggleDetailSidebar(true);
			}
		},
		toggleCustomerDialog(val = false) {
			this.customerDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailUserDialogActive = val;
		},
		toggleUserCustomerSidebar(val = false) {
			this.isDetailUserCustomerDialogActive = val;
		},
		handleSort(key, active) {
			const _key = key; // `_id.${key}`;
			this.sort = {};
			this.sort[_key] = active === "asc" ? 1 : -1;
			this.getGetUsers();
		},
		assignedZones(assignedZones) {
			// let _assignedZone = "";
			// Update property in user
			// assignedZones.map(assignedZone => {
			// 	_assignedZone = _assignedZone + (assignedZone.name + ", ");
			// });
			return assignedZones.reduce((zones, zone) => {
				zones += zone && zone.name ? `${zones ? ", " : ""}${zone.name}` : "";
				return zones;
			}, "");
			// _assignedZone = _assignedZone.slice(0, _assignedZone.lastIndexOf(","));
			// return _assignedZone;
		},
		showCustomerByUser(user) {
			this.detailUserCustomerDialogData = user;
			this.toggleUserCustomerSidebar(true);
		},
	},
	watch: {
		page() {
			this.getGetUsers();
		},
		searchText() {
			this.getGetUsers();
		},
	},
	created() {
		// Register Module UserManagement Module
		this.getGetUsers();
		this.getProducts();
		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { shipping_can_view = false, shipping_can_rating = false } = permissions;
			if (shipping_can_view) {
				this.canView = true;
			}
			if (shipping_can_rating) {
				this.canRating = true;
			}
			this.userToken = token;
		}
		let urlHash = location.hash;
		if (urlHash) {
			let id = parseInt(urlHash.replace('#', ''));
			// this.id = id;

			this.$store.dispatch("moduleProduct/getShipping", id).then(response => {
				this.customerData = response;
				this.customerDialog = true;
			});
		}
	},
};
</script>

<style lang="scss">
.btn-order-action {
	position: fixed !important;
	bottom: 20px;
	right: 10px;
	z-index: 9999;
}
#avatar-col {
	width: 10rem;
}

.vs-table--tbody-table {
	min-width: 300px !important;
}

#page-order-view {
	table {
		td:not(:first-child){
			vertical-align: top;
			// min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
</style>
